import { Theme } from "@mui/material";
import Chip, { chipClasses } from "@mui/material/Chip";
import { alpha, styled } from "@mui/material/styles";
import { COLORS } from "../../styles/sbDesignSystem/sbPalette";

const getColor = (severity: string, theme: Theme) => {
  switch (severity) {
    case "success":
      return theme.palette.accentSuccess30.main;
    case "warning":
      return theme.palette.accentWarning30.main;
    case "error":
      return theme.palette.accentDanger30.main;
    default:
      return theme.palette.accentInfo30.main;
  }
};

const Badge = styled(Chip, {
  shouldForwardProp: (prop) => prop !== "severity",
})<{ severity: string }>(({ severity, size, theme }) => ({
  backgroundColor: getColor(severity, theme),
  color: theme.palette.text10.main,
  fontSize: "12px",
  fontWeight: "600",
  gap: "8px",
  ...(size === "small" && { padding: "8px" }),
  [`.${chipClasses.icon}`]: {
    color: theme.palette.text10.main,
    textAlign: "center",
  },
  [`.${chipClasses.label}`]: {
    overflow: "visible",
  },
}));

const AccentBadge = styled(Chip, {
  shouldForwardProp: (prop) => prop !== "accentColor",
})<{ accentColor?: keyof typeof COLORS }>(({ theme, accentColor = "secondary40" }) => ({
  backgroundColor: alpha(theme.palette[accentColor].main, 0.05),
  border: `1.2px solid ${theme.palette[accentColor].main}`,
  color: theme.palette[accentColor].main,
  fontSize: 14,
  fontWeight: 600,
  [`& .${chipClasses.icon}`]: {
    color: theme.palette[accentColor].main,
  },
}));

export { AccentBadge, Badge };
